'use client';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { FeatureFlagValues } from '@/core/featureFlags';

const storedFlagsKey = 'lovevery-storedFlags';

export default function useFeature<K extends keyof FeatureFlagValues>(
  flagName: K,
): FeatureFlagValues[K] {
  const ldClient = useLDClient();
  const [variation, setVariation] = useState<FeatureFlagValues[K]>(
    undefined as FeatureFlagValues[K],
  );

  useEffect(() => {
    const ldVariation = ldClient?.variation(flagName);
    setVariation(ldVariation);
  }, [flagName, ldClient]);

  useEffect(() => {
    const storedFlags = JSON.parse(
      sessionStorage.getItem(storedFlagsKey) || '[]',
    );

    // To control the amount of data sent to amplitude/rudderstack.
    if (variation !== undefined && !storedFlags.includes(flagName)) {
      sessionStorage.setItem(
        storedFlagsKey,
        JSON.stringify([...storedFlags, flagName]),
      );
    }
  }, [variation, flagName]);

  return variation;
}
